import { createSelector } from 'reselect'

import { FETCH_STATUSES } from 'resources'

export const getSurvey = (state) => state.tngSurveys.survey

export const getSurveyCredit = createSelector(getSurvey, (survey) => survey?.credit || 0)

export const getQuestions = createSelector(getSurvey, (survey) => survey?.questions || [])

export const getAnswers = (state) => state.tngSurveys.answers || []

const getCurrentQuestionIndex = (state) => state.tngSurveys.currentQuestionIndex

const getCurrentQuestion = createSelector(
  [getQuestions, getCurrentQuestionIndex],
  (questions, currentQuestionIndex) => questions[currentQuestionIndex - 1] || null,
)

export const getCurrentAnswer = createSelector(
  [getAnswers, getCurrentQuestion],
  (answers, currentQuestion) => answers[currentQuestion?.fieldName] || null,
)

const getNextQuestionIndex = createSelector(
  [getQuestions, getCurrentQuestionIndex],
  (questions, currentQuestionIndex) => (questions.length > currentQuestionIndex ? currentQuestionIndex + 1 : null),
)

const killiSurveys = (state) => state.tngSurveys.list
const isKilliFetching = (state) => state.tngSurveys.fetchAllStatus === FETCH_STATUSES.FETCHING
const fetchSurveyError = (state) => state.tngSurveys.fetchSurveyStatus === FETCH_STATUSES.FAILURE
const fetchSurveySuccess = (state) => state.tngSurveys.fetchSurveyStatus === FETCH_STATUSES.SUCCESS

export default {
  getSurveyCredit,
  getQuestions,
  getSurvey,
  getCurrentQuestionIndex,
  getNextQuestionIndex,
  getAnswers,
  getCurrentAnswer,
  killiSurveys,
  isKilliFetching,
  fetchSurveyError,
  fetchSurveySuccess,
}
